import { render, staticRenderFns } from "./37.vue?vue&type=template&id=4088883a&scoped=true&"
var script = {}
import style0 from "./37.vue?vue&type=style&index=0&id=4088883a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4088883a",
  null
  
)

export default component.exports